import { types, Instance } from 'mobx-state-tree';

const { model, string, number, identifierNumber } = types;

export const InvoiceModel = model('InvoiceModel', {
  id: identifierNumber,
  adminId: number,
  subscriptionPlanPeriodId: number,
  paymentId: string,
  clientSecret: string,
  status: string,
  paymentMethodTypes: string,
  currency: string,
  amount: string,
  previousInvoiceId: number,
  amountFromPreviousPayment: string,
  originalAmount: string,
  paymentAt: string,
  addOnPrice: string,
  remainingBalanceFromPreviousPayment: string,
  payment_period: string,
});

export type IInvoiceModel = Instance<typeof InvoiceModel>;
